import { Component, Input, EventEmitter, Output } from '@angular/core';
import { Finish } from '../../models/Finish';
import { Style } from '../../models/Style';
import { MapifyMapTexts } from '../../models/MapifyMapTexts';
import { MapifyMapText } from '../../models/MapifyMapText';
import { MapifyMap } from '../../models/MapifyMap';
import { BehaviorSubject } from 'rxjs/BehaviorSubject';
import { UtilsService } from '../../services/utils.service';

@Component({
  selector: 'mpf-map-config-labels',
  templateUrl: './map-config-labels.component.html',
  styleUrls: ['./map-config-labels.component.scss']
})
export class MapConfigLabelsComponent {
  private _style: Style;

  constructor(public utils: UtilsService) {}

  @Input() map: MapifyMap;

  @Input()
  set style(style: Style) {
    this._style = style;

    // when a style changes it is possible that the current finish is not valid anymore for the new style.
    // so we have to ensure there is on finish selected
    this.ensureSelectedFinish();
  }

  get style(): Style {
    return this._style;
  }

  @Input() finish: Finish;
  @Output() finishChange = new EventEmitter<Finish>();

  private ensureSelectedFinish() {
    if (this.finish) {
      // find the selected finish in the new list, if it is not available anymore then just take the first one
      const finish = this.style.finishes.find(f => f.id === this.finish.id) || this.style.finishes[0];

      this.selectFinish(finish);
    }
  }

  toggleRomantic(romantic: boolean) {
    Object.keys(this.map.texts).forEach(key => {
      const text: MapifyMapText = this.map.texts[key];
      const textValue = text.value.getValue();
      let newFontFamily;
      let newTextValue;

      // each text has to be updated with the new font family according to the romantic toogle
      // and the text has to be changed to uppercase / capitalized
      if (romantic) {
        newFontFamily = 'Romantic';
        newTextValue = key !== 'description' ? this.utils.toProperCase(textValue) : textValue;
      } else {
        newFontFamily = 'Roboto';
        newTextValue = textValue.toUpperCase();
      }

      text.font.family.next(newFontFamily);
      text.value.next(newTextValue);
    });
  }

  selectFinish(finish: Finish) {
    this.finish = finish;
    this.finishChange.emit(finish);
  }

  isFinishSelected(finish: Finish) {
    return this.finish.id === finish.id;
  }
}



// WEBPACK FOOTER //
// /vercel/path0/src/app/components/map-config-labels/map-config-labels.component.ts